import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import * as Rx from 'rxjs';
import { Observable } from 'rxjs';


const  headers  =  new  HttpHeaders({'Content-Type': 'application/json;charset:utf-8', 'Access-Control-Allow-Origin': '*',
 'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});


@Injectable({
  providedIn: 'root'
})
export class LoginHistoryService {

  constructor(private http: HttpClient) { }

  loginHistoryUrl = '/superadmin/rest/mgmt/login/loginHistory?';
  countUrl =  '/superadmin/rest/mgmt/login/loginHistory/count?';


  getLoginHistory(
    filter, sortOrder,
    pageNumber, pageSize): Observable<any> {
    return this.http.get(this.loginHistoryUrl + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  getTotalFilterCount(filter): Observable<any> {
    return this.http.get(this.countUrl + filter, {headers});
  }
}
